import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import ShareIcon from "@mui/icons-material/Share";
import { RWebShare } from "react-web-share";
import { Box, Grid, Typography, Button } from "@mui/material";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css"; // Splide core styles
import { useSelector, useDispatch } from "react-redux";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SkillsComponent from "../components/resultpagecarousel/SkillsComponent";
import ToolsComponent from "../components/resultpagecarousel/ToolsComponent";
import ProfessionalBackgroundComponent from "../components/resultpagecarousel/ProfessionalBackgroundComponent";
import SmartSalaryContainer from "../components/resultpagecarousel/Techworth/SmartSalaryContainer";
import TechValueContainer from "../components/resultpagecarousel/Techworth/TechValueContainer";
import JobsLinkedinIndeed from "../components/resultpagecarousel/Techworth/JobsLinkedinIndeed";
import TechworthDialContainer from "../components/resultpagecarousel/Techworth/TechworthDialContainer";
import AiBoostYourCareer from "../components/resultpagecarousel/Topskill/AiBoostYourCareer";
import TopSkillValidity from "../components/resultpagecarousel/Topskill/TopSkillValidity";
import TrueEdgeContainer from "../components/resultpagecarousel/TrueEdge/TrueEdgeContainer";
import ReferencesContainer from "../components/resultpagecarousel/References/ReferencesContainer";
import { styled } from "@mui/material/styles";
import {
  setResultPageCarousel,
  setUserPublicResult,
} from "../redux/action/result";
import {
  getResultPageCarousel,
  getPublicResult,
} from "../components/stepper_form/stepper.helper";
import Loading from "../components/UI/Loading";
import ErrorComponent from "../components/common/ErrorComponent";
import { saveTargetPath } from "../utils/storage";
import analytics from "../utils/analytics";
import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";
import { useNavigate } from "react-router-dom";
import WorkActivitiesComponent from "../components/resultpagecarousel/WorkActivities";
import EducationalQualification from "../components/resultpagecarousel/EducationalQualification";
import Languages from "../components/resultpagecarousel/Languages";
import Hobbies from "../components/resultpagecarousel/Hobbies";
import WorkExperience from "../components/resultpagecarousel/WorkExperience";
import ProjectsCompo from "../components/resultpagecarousel/Projects";
import Achievements from "../components/resultpagecarousel/Achievements";

const ResultCarousel = () => {
  const dispatch = useDispatch();
  const path = window.location.pathname;
  const pathParts = path.split("/");
  const uuid = pathParts[pathParts.length - 1];
  const [pageLoading, setPageLoading] = useState(true);
  const [errorPublicPage, setErrorPublicPage] = useState({
    error: false,
    message: "",
    status: 400,
  });
  const MaintenanceMessage = useFeatureFlag("Maintenance_Break");
  const CalculateButtonValue = useFeatureFlag("Calculate_Button_text");
  const navigate = useNavigate();
  const OldFormReducer = useSelector((state) => state?.OldFormReducer || []);
  const previousResult = useSelector(
    (state) => state?.ResultReducer?.previousResult || []
  );
  useEffect(() => {
    getPublicResult(
      dispatch,
      setUserPublicResult,
      uuid,
      setPageLoading,
      setErrorPublicPage
    );
    // DeviceInfoAndLocation(setLocation, setDeviceInfo);
  }, []);
  const [shareLink, setShareLink] = useState(
    `${process.env.REACT_APP_BASE_URL}/public-result/${uuid}`
  );

  const resultData = useSelector(
    (state) => state?.ResultReducer?.publicResult || []
  );

  const Img = styled("img")({
    maxWidth: { xs: "35px !important", md: "56px" },
    maxHeight: "100%",
    width: "100%",
  });

  const userForm = useSelector(
    (state) => state?.ResultReducer?.publicResult?.userData
  );
  const resultPageCarousel = useSelector(
    (state) => state?.ResultReducer?.resultPageCarousel || []
  );

  useEffect(() => {
    getResultPageCarousel(dispatch, setResultPageCarousel);
  }, []);
  function GetBackGroundColor(skillDemand, type) {
    if (skillDemand === "Trending") {
      switch (type) {
        case "y":
          return "#278C37";
        case "tech":
          return "#278C37";
        case "mgmt":
          return "#30B044";
        case "management":
          return "#30B044";
        case "generic":
          return "#38C94E";
        default:
          return "#278C37";
      }
    }
    if (skillDemand === "Obsolete") {
      switch (type) {
        case "y":
          return "#028EDF";
        case "tech":
          return "#028EDF";
        case "mgmt":
          return "#09A2FA";
        case "management":
          return "#09A2FA";
        case "generic":
          return "#79CDFD";
        default:
          return "#028EDF";
      }
    }
    if (skillDemand === "In demand") {
      switch (type) {
        case "y":
          return "#E9B112";
        case "tech":
          return "#E9B112";
        case "mgmt":
          return "#FEC113";
        case "management":
          return "#FEC113";
        case "generic":
          return "#FAD15D";
        default:
          return "#E9B112";
      }
    }
    if (skillDemand === "Getting outdated fast") {
      switch (type) {
        case "y":
          return "#C60015";
        case "tech":
          return "#C60015";
        case "mgmt":
          return "#E2031B";
        case "management":
          return "#E2031B";
        case "generic":
          return "#FF465A";
        default:
          return "#C60015";
      }
    }
  }

  const componentMap = {
    SmartSalary: <SmartSalaryContainer />,
    TechValue: <TechValueContainer />,
    Jobs: <JobsLinkedinIndeed />,
    Speedometer: <TechworthDialContainer />,
    Skills: <SkillsComponent />,
    AllTools: resultData?.AllTools?.length !== 0 && <ToolsComponent />,
    ProfessionalBackground: <ProfessionalBackgroundComponent />,
    BoostYourCareer: <AiBoostYourCareer />,
    SkillDuration: <TopSkillValidity />,
    TrueEdge: resultData?.coverLetter !== "" && <TrueEdgeContainer />,
    References: <ReferencesContainer />,
    workActivities: resultData?.userData?.workActivities?.length > 0 && (
      <WorkActivitiesComponent />
    ),
    EducationalQualification: <EducationalQualification />,
    languages: resultData?.languages && <Languages />,
    hobbies_interests: resultData?.hobbies_interests && <Hobbies />,
    workExperience: resultData?.workExperience && <WorkExperience />,
    achievements: resultData?.achievements && <Achievements />,
    projects: resultData?.projects && <ProjectsCompo />,
  };

  // Filter and sort sections based on the "order" and "visible" properties
  const sortedSections = resultPageCarousel
    .filter((section) => section.visible)
    .sort((a, b) => a.order - b.order);
  return (
    <>
      {/* Header Section */}
      <Header />
      {pageLoading ? (
        <Loading />
      ) : errorPublicPage.error === true ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            my: 30,
            gap: 4,
          }}
        >
          <ErrorComponent errorWithStatus={errorPublicPage} />
          <Box p={1} className={"calculate-your-tech-worth"}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0D9B21",
                "&:hover": {
                  backgroundColor: "#fff !important",
                  color: "#0D9B21",
                  borderColor: "#fff",
                },
              }}
              onClick={() => {
                analytics.trackClickCTA("calculate_salary", "public_result_page");
                if (MaintenanceMessage != "undefined") {
                  setResponsiveDialog(true);
                } else {
                  navigate("/skills-calculation");
                  saveTargetPath(window.location.pathname);
                }
              }}
            >
              {CalculateButtonValue}
            </Button>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            mt: { xs: 8, lg: 14 },
            py: { xs: 3, sm: 3, md: 3, lg: 3, xl: 0 },
          }}
        >
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                // gap: 2,
                flexWrap: "wrap",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                mb: { xs: "16px", sm: "16px", md: 3 },
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "25px", md: "35px", lg: "40px" },
                  fontWeight: 600,
                  textAlign: { xs: "center", lg: "center" },
                  lineHeight: { xs: "30px", md: "40px", lg: "50px" },
                  color: "transparent",
                  backgroundImage:
                    "linear-gradient(to right, #2BB344, #FFC218, #E0011C, #0BA2FF)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  flexGrow: 1,
                  wordWrap: "break-word",
                  // mt: "20px !important",
                }}
              >
                {`${resultData?.name?.trim()}'s`}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "25px", md: "35px", lg: "40px" },
                  fontWeight: 600,
                  textAlign: { xs: "center", lg: "center" },
                  lineHeight: { xs: "30px", md: "40px", lg: "50px" },
                  color: "transparent",
                  backgroundImage:
                    "linear-gradient(to right, #2BB344, #FFC218, #E0011C, #0BA2FF)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  flexGrow: 1,
                  wordWrap: "break-word",
                  // mt: "20px !important",
                }}
              >
                TechWorth
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    display: { xs: "flex", sm: "flex" },
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <Box
                    component="div"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: "14px", lg: "16px" },
                        textAlign: { xs: "center", lg: "center" },
                        display: "flex",
                        alignItems: "center",
                        margin: { xs: "0 auto", sm: "0 auto" },
                      }}
                    >
                      <LocationOnIcon
                        sx={{
                          fontSize: "inherit",
                          color: "#2BB344",
                          marginRight: "-2px",
                        }}
                      />
                      <span style={{ color: "#2BB344", fontSize: "inherit" }}>
                        Work location:&nbsp;
                      </span>
                      {userForm?.location}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Box
                      component="div"
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        ml: "10px",
                      }}
                    >
                      <RWebShare
                        data={{
                          text: "Here is something interesting for you.",
                          url: shareLink,
                          title: "Check this out!",
                        }}
                        onClick={() =>
                          console.log("shared successfully! public page")
                        }
                      >
                        <Button
                          className={"refer-a-friend"}
                          sx={{
                            backgroundColor: "#2BB344",
                            display: "flex",
                            pl: "10px !important",
                            pr: "10px !important",
                            color: "#fff",
                            alignItems: "center",
                            borderRadius: "8px",
                            "&:hover": {
                              backgroundColor: "#2BB344 !important",
                              color: "#fff",
                            },
                          }}
                        >
                          <ShareIcon fontSize="small" />
                        </Button>
                      </RWebShare>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Typography
                sx={{
                  fontSize: { xs: "10px", lg: "14px" },
                  textAlign: { xs: "center", lg: "center" },
                  marginTop: "10px",
                }}
              >
                <span style={{ color: "#2BB344" }}> Result Id: </span>
                {resultData?._id}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                mb: "32px",
              }}
            >
              <Box>
                <Img
                  sx={{ width: { xs: "38px", md: "100%" } }}
                  src="/assets/images/person-star-green.svg"
                  alt="techworth"
                  loading="lazy"
                />
              </Box>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "600",
                  textAlign: "center",
                  pl: { xs: 1, lg: 2 },
                  fontSize: { xs: "0.9rem", md: "1.4rem" },
                }}
              >
                {isNaN(resultData?.userData?.experience)
                  ? `Total experience of ${resultData?.experience} with`
                  : (() => {
                      const totalMonths = parseInt(
                        resultData?.userData?.experience,
                        10
                      );

                      // Convert months to years and months
                      const years = Math.floor(totalMonths / 12);
                      const months = totalMonths % 12;

                      // Build the experience string
                      let experienceText = "";
                      if (years > 0) {
                        experienceText += `${years} ${
                          years > 1 ? "Years" : "Year"
                        }`;
                      }
                      if (months > 0) {
                        experienceText += ` ${months} ${
                          months > 1 ? "Months" : "Month"
                        }`;
                      } else if (totalMonths === 0) {
                        return `Fresher/Intern/Trainee with`;
                      }
                      // if(months)

                      return `Total experience of ${experienceText} with`;
                    })()}
              </Typography>
            </Box>
          </Grid>
          <Splide
            options={{
              type: "loop",
              perPage: 1,
              perMove: 1,
              gap: "1rem",
              pagination: true,
              arrows: true, // Enable navigation arrows
              autoplay: true, // Disable autoplay
              speed: 600, // Animation speed
              breakpoints: {
                640: { gap: "0.5rem" }, // Mobile responsiveness
              },
            }}
            style={{
              padding: "1rem 0",
              position: "relative",
            }}
          >
            {sortedSections.map((section) => {
              const Component = componentMap[section.sectionName];

              return (
                <>
                  {section.sectionName === "Skills" ||
                  section.sectionName === "ProfessionalBackground"
                    ? Component // Directly render the component without wrapping in SplideSlide
                    : Component && (
                        <SplideSlide key={section.sectionName}>
                          {Component}
                        </SplideSlide>
                      )}
                </>
              );
            })}

            {/* <ProfessionalBackgroundComponent /> */}
          </Splide>

          {/* Inline Styling for Custom Navigation Arrows */}
          <style>
            {`
        .splide__arrow {
          background-color: #2bb344;
          color: white;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .splide__arrow:hover {
          background-color: #229b3c;
        }

        .splide__pagination {
          margin-top: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .splide__pagination__page {
          background: #ddd;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin: 0 3px;
          cursor: pointer;
          transition: background 0.3s ease;
        }

        .splide__pagination__page.is-active {
          background: #2bb344;
        }

       /* Center content inside slides */
          // .splide__slide {
          //   align-content: center;
          // }

        /* margin the arrows for desktop */
        @media (min-width: 1440px) {
          .splide__arrow {
              margin-left: 80px;
              margin-right: 80px;
          }
        }
        `}
          </style>
        </Box>
      )}
    </>
  );
};

export default ResultCarousel;
